import axios from "axios";
import { HOST_API_KEY } from "../config-global";
import { setSession } from "../utils/utils";

const axiosApi = axios.create({
  baseURL: HOST_API_KEY,
});

axiosApi.interceptors.request.use(
  request => {
      if (localStorage.getItem('accessToken')) {
          request.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`
      }
      return request
})

axiosApi.interceptors.response.use(
  (response) => {
    const token = response?.data?.token;

    if (token) {
      setSession(token);
    }
    
    return response},
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, config)
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, data, config)
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, data, config)
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, config)
    .then((response) => response.data);
}
